// extracted by mini-css-extract-plugin
export var content = "_7y-3";
export var list = "_7y-4";
export var settingsContent = "_7y-7";
export var settingsPanel = "_7y-8";
export var state = "_7y-6";
export var triggerBadge = "_7y-2";
export var triggerButton = "_7y-1";
export var triggerShell = "_7y-0";
export var unreadDot = "_7y-5";